const insuranceVendorReducer = (state = '', action) => {
	switch(action.type){
	case 'LEISURE':	
		return 'LeisureCare Travel Insurance';
	case 'OTHER':
		return action.payload;
	default:
		return state;
	}
}

export default insuranceVendorReducer;
